import React from "react";

const Others = () => {
  return (
    <div className="skills_content">
      <h3 className="skills_title">Other Essentials</h3>
      <div className="skills_box">
        <div className="skills_group">
          <div className="skills_data">
            <i class="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">Jira</h3>
              <span className="skills_level">Advanced</span>
            </div>
          </div>
          <div className="skills_data">
            <i class="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">Android Studio</h3>
              <span className="skills_level">Intermediate</span>
            </div>
          </div>
          <div className="skills_data">
            <i class="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">Expo</h3>
              <span className="skills_level">Intermediate</span>
            </div>
          </div>
        </div>
        <div className="skills_group">
          <div className="skills_data">
            <i class="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">VS Code</h3>
              <span className="skills_level">Advanced</span>
            </div>
          </div>
          <div className="skills_data">
            <i class="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">Git</h3>
              <span className="skills_level">Intermediate</span>
            </div>
          </div>
          <div className="skills_data">
            <i class="bx bx-badge-check"></i>

            <div>
              <h3 className="skills_name">Netlify</h3>
              <span className="skills_level">Intermediate</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Others;
